<template>
  <div class='lineChart'>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="queryInfo" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="queryInfo.wareId" placeholder="仓房选择" @change="queryLine">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="queryInfo.beginTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOpts"
            @change="queryLine"
            placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="queryInfo.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="endPickerOpts"
            @change="queryLine"
            placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <div class='setTabView' :style="`height:${height-50}px;width:${width-60}px`">
            <div class='setEchartWrap' ref='echartLine' id='setEchartWrap' :style="`height:${height-50}px;width:${width-60}px`"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
    macType:String
  },
  data(){
    return{
      queryInfo:{
        wareId:'',
        beginTime:'',
        endTime:''
      },
      wareList:[],
      echartLine:'',
      lineData:[],
      startPickerOpts:{
        disabledDate:(t)=>{
          return this.queryInfo.endTime?t.getTime()>new Date(this.queryInfo.endTime).getTime()-86400000:false
        }
      },
      endPickerOpts:{
        disabledDate:(t)=>{
          return this.queryInfo.beginTime?t.getTime()<new Date(this.queryInfo.beginTime).getTime():false
        }
      }
    }
  },
  created(){
    this.getWareList()
  },
  watch:{
    macType(){
      this.getWareList()
    }
  },
  mounted(){
    this.echartLine=this.$echarts.init(document.getElementById('setEchartWrap'));
    this.resizeFun=()=>{
      this.echartLine.resize();
    }
    window.addEventListener('resize',this.resizeFun)
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.resizeFun);
    this.resizeFun= null
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
          this.queryInfo={
            wareId:res.data[0].wareId
          }
          this.getLineData()
        }
      })
    },
    queryLine(){
      this.getLineData()
    },
    getLineData(){
      let url='',info='';
      if(this.macType=='DEVGASSYS'){
        url='/system/gasHis/gasLine';
        info='无气体浓度检测数据'
      }else if(this.macType=='grain-1'){
        url='/system/grain/weekTemp';
        info='无粮温检测数据'
      }else if(this.macType=='grain-2'){
        url='/system/grain/threeTemperatures';
        info='无粮温检测数据'
      }else if(this.macType=='DEVAIRCOND'){
        url='/system/energyHis/selectLineInfo';
        info='无空调能耗数据'
      }
      axios.get(url,{params:this.queryInfo}).then(res=>{
        if(res){
          let data=res.data;
          if(data.length==0){
            this.$message({
              type: 'error',
              message: info,
              duration:1000
            }); 
          }
          this.lineData=data;
          this.setEchart()
        }
      })
    },
    setEchart(){
      let interval=Math.floor(this.lineData.length/20);
      let timelist=[],series=[],color=[],legend=[],option={};
      if(this.macType=='DEVGASSYS'){
        timelist = this.lineData.map(item => {
          return item.createTime
        })
        color = ["#01dd26", 'red'];
        let o2List = this.lineData.map(item => {
          return item.o2
        })
        let ph3List = this.lineData.map(item => {
          return item.ph3
        })
        let so2f2List = this.lineData.map(item => {
          return item.so2f2
        })
        let interval = Math.floor(timelist.length / 10) || 1;

        series = [{
          name: '氧气',
          type: 'line',
          smooth: true,
          data: o2List,
          xAxisIndex: 0,
          yAxisIndex: 0
        }, {
          name: '磷化氢',
          type: 'line',
          smooth: true,
          data: ph3List,
          xAxisIndex: 1,
          yAxisIndex: 1
        }, {
          name: '硫酰氟',
          type: 'line',
          smooth: true,
          data: so2f2List,
          xAxisIndex: 2,
          yAxisIndex: 2
        }]

        option = {
          title: [{
            text: '氧气浓度变化曲线',
            left: 'center'
          }, {
            text: '磷化氢浓度变化曲线',
            left: 'center',
            top: '34%'
          }, {
            text: '硫酰氟浓度变化曲线',
            left: 'center',
            top: '68%'
          }],
          visualMap: [{
            show: false,
            type: 'continuous',
            min: 19.5,
            max: 20.9,
            seriesIndex: 0,
            inRange: {
              color: ["#f61005", "#fd7c00", "#f9e600", "#01dd26", "#f9e600", "#fd7c00", "#f61005"]
            }
          }, {
            show: false,
            type: 'continuous',
            min: 0.2,
            max: 50,
            seriesIndex: 1,
            inRange: {
              color: ["#01dd26", "#f9e600", "#fd7c00", "#f61005"]
            }
          }, {
            show: false,
            type: 'continuous',
            min: 0,
            max: 10,
            seriesIndex: 2,
            inRange: {
              color: ["#01dd26", "#f9e600", "#fd7c00", "#f61005"]
            }
          }],
          tooltip: { trigger: 'axis' },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: { show: true }
            }
          },
          grid: [
            { left: '5%', right: '5%', top: '7%',  bottom: '70%', containLabel: true },
            { left: '5%', right: '5%', top: '37%', bottom: '37%', containLabel: true },
            { left: '5%', right: '5%', top: '70%', bottom: '3%',  containLabel: true }
          ],
          xAxis: [
            {
              name: '时间',
              type: 'category',
              data: timelist,
              nameTextStyle: { align: 'center' },
              axisLine: { lineStyle: { color: "#1e2d4e" } },
              axisLabel: { fontSize: 12, color: "#657c97", interval: interval, rotate: 45 },
              boundaryGap: false,
              gridIndex: 0
            },
            {
              name: '时间',
              type: 'category',
              data: timelist,
              nameTextStyle: { align: 'center' },
              axisLine: { lineStyle: { color: "#1e2d4e" } },
              axisLabel: { fontSize: 12, color: "#657c97", interval: interval, rotate: 45 },
              boundaryGap: false,
              gridIndex: 1
            },
            {
              name: '时间',
              type: 'category',
              data: timelist,
              nameTextStyle: { align: 'center' },
              axisLine: { lineStyle: { color: "#1e2d4e" } },
              axisLabel: { fontSize: 12, color: "#657c97", interval: interval, rotate: 45 },
              boundaryGap: false,
              gridIndex: 2
            }
          ],
          yAxis: [
            {
              name: '浓度(%)',
              type: "value",
              scale: true,
              nameTextStyle: { fontSize: 12, fontFamily: "微软雅黑" },
              // ✅ 关键：把Y轴名字往左边挪，不侵入下一个图表
              nameGap: 30,
              gridIndex: 0
            },
            {
              name: '浓度(ppm)',
              type: "value",
              scale: true,
              nameTextStyle: { fontSize: 12, fontFamily: "微软雅黑" },
              nameGap: 30,
              gridIndex: 1
            },
            {
              name: '浓度(ppm)',
              type: "value",
              scale: true,
              nameTextStyle: { fontSize: 12, fontFamily: "微软雅黑" },
              nameGap: 30,
              gridIndex: 2
            }
          ],
          series: series
        }
      }else if(this.macType=='DEVAIRCOND'){
        timelist=this.lineData.map(item=>item.date);
        let data=this.lineData.map(item=>item.znh);
        color=['#01DD26'];
        series=[{
          name:'能耗(Kw·h)',
          type:'line',
          smooth:true,
          data:data
        }];
        option={
          title:{
            text:'能耗变化曲线图',
            left:'20'
          },
          tooltip:{trigger:'axis'},
          legend:{
            data:legend
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: { show: true }
            }
          },
          grid: {
            bottom: "1%",
            left:'5%',
            right:'5%',
            containLabel: true
          },
          xAxis : [{
            name:'时间',
            type : 'category',
            data :timelist,
            grid:{
              left:'20%',
              bottom:'38%'
            },
            nameTextStyle:{
              align:'center'
            },
            axisLine: {
              lineStyle: {
                color: "#1e2d4e"
              },
            },
            axisLabel: {
              fontSize : 12,
              color: "#657c97",
              interval:interval,
              rotate:45
            },
            boundaryGap:false
          }],
          yAxis : [{
            name:'能耗(Kw·h)',
            nameTextStyle : {
                fontSize : 12, 
                fontFamily : "微软雅黑"
            },
            type: "value",
            scale:'true'
          }],
          color:color,
          series :series
        }
      }else{
        if(this.macType=='grain-1'){
          timelist=this.lineData.map(item=>{
            return item.date
          });
          let zavelist=this.lineData.map(item=>{
            return item.zave
          })
          let navelist=this.lineData.map(item=>{
            return item.nave
          })
          legend=['内均温','周均温'];
          color=["#3562ff",'red'];
          series=[{
            name:'内均温',
            type: 'line',
            smooth:true,
            data:navelist
          },{
            name:'周均温',
            type: 'line',
            smooth:true,
            data: zavelist
          }]
        }else if(this.macType=='grain-2'){
          timelist=this.lineData.map(item=>{
            return item.date
          });
          let maxlist=this.lineData.map(item=>{
            return item.max
          })
          let minlist=this.lineData.map(item=>{
            return item.min
          })
          let avelist=this.lineData.map(item=>{
            return item.ave
          })
          let inTemplist=this.lineData.map(item=>{
            return item.inTemp
          })
          let outTemplist=this.lineData.map(item=>{
            return item.outTemp
          })
          legend=['最高温','最低温','平均温','仓内温','仓外温'];
          color=["red","#01dd26","orange","#f9e600",'#ea7ccc'];
          series = [{
            name:'最高温',
            type:'line',
            smooth:true,
            data:maxlist
          },{
            name:'最低温',
            type:'line',
            smooth:true,
            data:minlist
          },{
            name:'平均温',
            type:'line',
            smooth:true,
            data:avelist
          },{
            name:'仓内温',
            type:'line',
            smooth:true,
            data:inTemplist
          },{
            name:'仓外温',
            type:'line',
            smooth:true,
            data:outTemplist
          }]
        }
        option={
          title:{
            text:'温度变化曲线',
            left:'20'
          },
          tooltip:{trigger:'axis'},
          legend:{
            data:legend
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: { show: true }
            }
          },
          grid: {
            bottom: "1%",
            left:'5%',
            right:'5%',
            containLabel: true
          },
          xAxis : [{
            name:'时间',
            type : 'category',
            data :timelist,
            grid:{
              left:'20%',
              bottom:'38%'
            },
            nameTextStyle:{
              align:'center'
            },
            axisLine: {
              lineStyle: {
                color: "#1e2d4e"
              },
            },
            axisLabel: {
              fontSize : 12,
              color: "#657c97",
              interval:interval,
              rotate:45
            },
            boundaryGap:false
          }],
          yAxis : [{
            name:'温度(℃)',
            nameTextStyle : {
                fontSize : 12, 
                fontFamily : "微软雅黑"
            },
            type: "value",
            scale:'true'
          }],
          color:color,
          series :series
        }
      }
      this.echartLine.setOption(option,true)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
